import CreditPolicyCompliance from './CreditPolicyCompliance'

export default CreditPolicyCompliance
